<template>
  <div class="header_banner" ref="headerBanner">
    <div class="size">
      <transition name="expand">
        <template v-if="advertise">
          <div
            v-if="isOpen"
            class="banner cursor"
            :style="{
              backgroundImage: 'url(' + advertise.image + ')'
            }"
            @click="goPage(advertise.url)"
          >
            <a class="cl_bt" href="javascript:;" @click="closeHeaderBanner">
            </a>
          </div>
        </template>
        <template v-else>
          <div
            v-if="isOpen"
            class="banner"
            :style="{
              backgroundImage: 'url(' + banner.image + ')'
            }"
          >
            <a class="cl_bt" href="javascript:;" @click="closeHeaderBanner">
            </a>
          </div>
        </template>
      </transition>
    </div>
  </div>
</template>

<script>
import { advertiseList } from '@/api/homeData'

export default {
  name: 'HeaderBanner',
  props: {
    bannerHeight: {
      default: false
    }
  },
  data() {
    return {
      isOpen: true,
      banner: {
        image: require('@/assets/images/banner.png')
      },
      advertise: null,
      advertiseList: []
    }
  },
  methods: {
    closeHeaderBanner() {
      this.isOpen = !this.isOpen
      // 브라우저가 닫힐 경우 다시 노출되는 것이 맞는 것 같아 sessionStorage에 담았음
      sessionStorage.setItem('isOpenBanner', this.isOpen)
    },
    matchHeight() {
      this.$emit('update:bannerHeight', this.$refs.headerBanner.clientHeight)
    },
    getBannerList() {
      advertiseList(0).then(res => {
        this.advertiseList = res.data
        this.advertise = res.data[0]
      })
    },
    goPage(url) {
      if (url.match(/(http:\/\/)|(https:\/\/)/g)) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    }
  },
  mounted() {
    this.matchHeight()
  },
  created() {
    this.getBannerList()
    this.isOpen = !sessionStorage.getItem('isOpenBanner')
  }
}
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition: max-height 0.5s ease;
  max-height: 400px;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  overflow: hidden;
}

.list {
  box-shadow: 1px 0 10px #aaa;
  padding: 8px;
  width: 64px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Header/HeaderBanner.vue